import axios from 'axios'
import * as API_LINKS from '../../../configurations/links'
import {toast} from 'react-toastify'
import cookie from 'react-cookies'

export const FETCH_BUDGET_CHILDREN = 'FETCH_BUDGET_CHILDREN'
export const RECEIVE_BUDGET_CHILDREN = 'RECEIVE_BUDGET_CHILDREN'
export const FAILED_BUDGET_CHILDREN = 'FAILED_BUDGET_CHILDREN'

export function fetchBudgetYearlyChildren(_data){
    return (dispatch, getState) => {
        dispatch({type: FETCH_BUDGET_CHILDREN})
        axios({
            method: 'POST',
            url: API_LINKS.BUDGET_YEARLY_CHILDREN_URL,
            headers: {
                Authorization: cookie.load('token')
            },
            data: _data
        })
        .then((response) => {
            if(response.status === 200){
                if(response.data.status === "success"){
                    dispatch({
                        type: RECEIVE_BUDGET_CHILDREN,
                        payload: response.data.result
                    })
                } else {
                    dispatch({
                        type: FAILED_BUDGET_CHILDREN
                    })
                }
            } else {
                dispatch({
                    type: FAILED_BUDGET_CHILDREN
                })
            }
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_BUDGET_CHILDREN
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 403) {
                    dispatch({
                        type: FAILED_BUDGET_CHILDREN
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_BUDGET_CHILDREN
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_BUDGET_CHILDREN
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else {
                    dispatch({
                        type: FAILED_BUDGET_CHILDREN
                    })
                    return toast.error('Something went wrong... Please try again later...')
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_BUDGET_CHILDREN
                })
                return toast.error('Request have no response! Please check on your internet connection and refresh this page.')
            } else {
                dispatch({
                    type: FAILED_BUDGET_CHILDREN
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/budgeting/aBudget-YearlyChildren.jsx